import React from "react";
import Header from "../Components/Header";
import "./Cart.css";
import cartImg from "../assets/images/cartImg.png";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";
import ship from "../assets/images/ship.png"
import secure from "../assets/images/secure.png";
import { useState } from "react";
import { Link } from "react-router-dom"; //Link

export default function Cart() {

const [counter, setCounter] = useState(1);
  const inc = () => {
    setCounter(counter + 1);
  };

  const dec = () => {
    if (counter > 1) {
      setCounter(counter - 1);
    }
  };

  const [counter2, setCounter2] = useState(1);
  const inc2 = () => {
    setCounter2(counter2 + 1);
  };

  const dec2 = () => {
    if (counter2 > 1) {
      setCounter2(counter2 - 1);
    }
  };

   const [counter3, setCounter3] = useState(1);
  const inc3 = () => {
    setCounter3(counter3 + 1);
  };

  const dec3 = () => {
    if (counter3 > 1) {
      setCounter3(counter3 - 1);
    }
  };



  return (
    <>
      <Header mode="dark" />

      <div className="cart_main">
        <div className="container-fluid">
          <div className="breadcrumb_title detail_page_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="/products">Shop</Breadcrumb.Item>
              <Breadcrumb.Item active>Cart</Breadcrumb.Item>
            </Breadcrumb>
          </div>

       

          <div className="cart-page">
            <div className="container-fluid">
            <div className="row">
              <div className="col-lg-8">
                <h4 className="cart-title">Cart Items</h4>

                <div className="cart-item">
                  <img src={cartImg} alt="" className='img-fluid'/>

                  <div className="cart-details">
                    <div className="cart-name">
                      Nazakat Hand Woven Beige Cotton Cushion Cover
                    </div>
                    <div className="cart-meta">SKU: CU03970001_1.04x1.04</div>
                    <div className="cart-meta">Size: 46x46 cm</div>
                    <div className="cart-meta">Color: Cream</div>

                    <div>
                      <div className="qty-box">
                        <button onClick={dec3}>-</button>
                          <p className="number">{counter3}</p>
                          <button onClick={inc3}>+</button>
                      </div>
                      <span className="wishlist">Add to Wishlist</span>
                    </div>
                  </div>

                  <div className="cart-price">
                    ₹ 3,000
                    <button className="remove-btn">×</button>
                  </div>
                </div>

                <div className="cart-item">
                  <img src={cartImg} alt="" className='img-fluid'/>

                  <div className="cart-details">
                    <div className="cart-name">
                      Nazakat Hand Woven Beige Cotton Cushion Cover
                    </div>
                    <div className="cart-meta">SKU: CU03970001_1.04x1.04</div>
                    <div className="cart-meta">Size: 46x46 cm</div>
                    <div className="cart-meta">Color: Cream</div>

                    <div>
                      <div className="qty-box">
                          <button onClick={dec2}>-</button>
                          <p className="number">{counter2}</p>
                          <button onClick={inc2}>+</button>
                      </div>
                      <span className="wishlist">Add to Wishlist</span>
                    </div>
                  </div>

                  <div className="cart-price">
                    ₹ 3,000
                    <button className="remove-btn">×</button>
                  </div>
                </div>

                <div className="cart-item">
                  <img src={cartImg} alt="" className='img-fluid'/>

                  <div className="cart-details">
                    <div className="cart-name">
                      Nazakat Hand Woven Beige Cotton Cushion Cover
                    </div>
                    <div className="cart-meta">SKU: CU03970001_1.04x1.04</div>
                    <div className="cart-meta">Size: 46x46 cm</div>
                    <div className="cart-meta">Color: Cream</div>

                    <div>
                      <div className="qty-box">
                          <button onClick={dec}>-</button>
                          <p className="number">{counter}</p>
                          <button onClick={inc}>+</button>
                      </div>
                      <span className="wishlist">Add to Wishlist</span>
                    </div>
                  </div>

                  <div className="cart-price">
                    ₹ 3,000
                    <button className="remove-btn">×</button>
                  </div>
                </div>
                
              </div>

              <div className="col-lg-4">
                <div className="cart-summary">
                  <div className="summary-title">Cart Total</div>

                  <div className="summary-row">
                    <span>Subtotal (2 Items)</span>
                    <span>₹ 6,000</span>
                  </div>

                  <div className="summary-row">
                    <span>Tax</span>
                    <span>₹ 800</span>
                  </div>

                  <div className="summary-row">
                    <span>Shipping</span>
                    <span>Free</span>
                  </div>

                  <div className="summary-divider"></div>

                  <div className="summary-row summary-total">
                    <span>Total</span>
                    <span>₹ 6,800</span>
                  </div>

                  <button className="checkout-btn">   <Link to="/checkout"> Proceed to Checkout </Link></button>
                  <button className="back-btn"><Link to="/">Back to Shopping </Link></button>
                </div>

                <div className="info-box">
                  <div className="info-item">
                    <div className="info-icon">
                      <img src={ship} alt="" className='img-fluid'/>
                    </div>
                    <div>
                      <div className="info-title">Free Shipping</div>
                      <div className="info-sub">On orders over ₹2000</div>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <img src={secure} alt="" className='img-fluid'/>
                    </div>
                    <div>
                      <div className="info-title">Secure Packaging</div>
                      <div className="info-sub">
                        Art safely packed & insured
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>

        </div>
      </div>

      <Feature />
      <Footer />




    </>
  );
}
